import React from 'react'
import { ThemeProvider } from 'styled-components'
import GlobalStyle from '../../GlobalStyle'
import { defaultTheme } from '../../themes'

const ThemeWrapper = ({ children, theme }) => {
  return (
    <ThemeProvider theme={theme || defaultTheme}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  )
}

export default ThemeWrapper
